<template>
  <section class="vod-player">
    <div class="video-wrap" v-adjust-height>
      <div class="player-top-contents">
        <div id="container" ref="container" class="video-container"></div>
      </div>

      <!-- 채널 편성표 -->
      <div class="player-bottom-contents" :key="channelId">

        <!-- 라이브 하단 프로그램 정보 부분 -->
        <div>
          <h1 tabindex="0">
            <span class="episode-number">{{ get(channelInfo, 'channelname', '') }} {{ replaceTitle(get(channelInfo, 'title', ''))}}</span>
          </h1>
          <div class="player-bottom-utils">
            <player-action-button-for-live v-if="channelInfo && !isVisible" :content-info="channelInfo" content-type="live" :title="title" :action="action" :key="channelId"></player-action-button-for-live>
          </div>
          <div class="program-info-box">
            <span>{{ get(channelInfo, 'starttime', '')}} ~ {{ get(channelInfo, 'endtime', '')}}</span>
          </div>
          <ul class="icon-box">
            <li class="icon-item" v-if="!isPooqzone">
              <btn-zzim-with-api :isOn="get(channelInfo,'zzim', '')"
                        contents-type="live"
                        :contents-id="get(channelInfo, 'channelid', '')"
                        :key="get(channelInfo, 'channelid', '')"/>
            </li>
            <li class="icon-item">
              <button type="button" v-if="!isPooqzone" @click.prevent="openSharePopup">
                <img src="../../assets/images/common/element-icons-30-x-30-ic-detail-share.svg" width="30" height="30" alt="공유">
                <span class="icon-txt">공유</span>
              </button>
            </li>
            <li class="icon-item">
              <a href="#" @click.prevent="openScheduleOnNewTab">
                <img src="../../assets/images/common/element-icons-30-x-30-ic-detail-schd-off.svg" width="30" height="30" alt="전체 편성표">
                <span class="icon-txt">전체 편성표</span>
              </a>
            </li>
            <li class="icon-item" v-if="isVisibleVodButton">
              <a href="#" @click.prevent="goVodPlayer">
                <img src="../../assets/images/common/element-icons-30-x-30-ic-detail-vod.svg" width="30" height="30" alt="VOD 보기">
                <span class="icon-txt">VOD 보기</span>
              </a>
            </li>
          </ul>
        </div>
        <template>
          <section class="live-schedule-box">
            <h2 class="live-schedule-hd" tabindex="0">채널 편성표</h2>
            <epg-slider :channel-id="channelInfo.channelid"
                        :is-home-shopping="isHomeShopping"
                        :data-home-shopping="dataHomeShopping"
                        :data-home-shopping-add-info="dataHomeShoppingAddInfo"
                        :key="channelInfo.channelid"></epg-slider>
          </section>
        </template>
      </div>
    </div>
  </section>
</template>

<script>
import _ from 'lodash'
import { getVodProgramsContentid } from '@/common/utils/request'
import cookie from '@/common/utils/cookie'
import { addPostfixAndUrl, destroyPlayer, detachPlayerEvents, getUserInfo, titleTagNameChange } from '@/common/utils/common'
import {
  getNoneCredentialUserInfo, PLAYER_OPTIONS,
  PLAYER_PACKAGE_TYPE,
  playerDelegate,
  PlayerType
} from '@/common/utils/scalable.player'
import PlayerActionButtonForLive from '@/components/player/PlayerActionButtonForLive'
import EpgSlider from '@/components/player/EpgSlider'
import { PLAYER_UPDATE_EVENT } from '@/common/resources/const'
import { adjustHeight } from '@/common/resources/directives'
import BtnZzimWithApi from '@/components/button/BtnZzimWithApi'
import { actionButtonStateInfoData } from '@/common/utils/player.action.button'

export default {
  components: {
    BtnZzimWithApi,
    EpgSlider,
    PlayerActionButtonForLive
  },
  directives: {
    adjustHeight
  },
  props: {
    channelInfo: {
      type: Object
    },
    dataHomeShopping: {
      type: Object
    },
    dataHomeShoppingAddInfo: {
      type: Object
    },
    openDownloadPopup: {
      type: Function
    },
    openSharePopup: {
      type: Function
    }
  },
  data () {
    return {
      isPooqzone: cookie.isWavveOn(),
      isVisibleVodButton: false,
      title: '',
      action: '',
      isVisible: true
    }
  },
  computed: {
    logoStyle () {
      return `background-image:url('${addPostfixAndUrl(this.channelInfo.circleimage, '90')}');`
    },
    channelId () {
      return _.get(this.channelInfo, 'channelid', '')
    },
    isHomeShopping () {
      return _.get(this.channelInfo, 'homeshopping', 'N').toUpperCase() === 'Y'
    }
  },
  methods: {
    get: _.get,
    goVodPlayer () {
      const programId = _.get(this.channelInfo, 'programid', '')
      this.$router.push(`/player/vod?programid=${programId}`)
    },
    openScheduleOnNewTab () {
      window.open(`${location.origin}/schedule/index.html`, '_blank')
    },
    // 플레이어 초기화
    playerInit () {
      // destroyPlayer()
      if (cookie.getCredential() === 'none') {
        if (window.playerInstance) {
          window.playerInstance.setUserInfo(getNoneCredentialUserInfo())
          window.playerInstance.load('live', this.channelId)
        }
      } else {
        getUserInfo().then((userInfo) => {
          if (window.playerInstance) {
            window.playerInstance.setUserInfo(userInfo)
            window.playerInstance.load('live', this.channelId)
          }
        })
      }
    },
    replaceTitle (title) {
      return title.replace(/&lt;/g, '<').replace(/&gt;/g, '>')
    },
    updateVodButton (channelInfo) {
      const programId = _.get(channelInfo, 'programid', '')

      if (programId === '') {
        this.isVisibleVodButton = false
      } else {
        getVodProgramsContentid({ programid: programId }).then(({ data }) => {
          const contentId = _.get(data, 'contentid', '')
          if (contentId !== '') {
            this.isVisibleVodButton = true
          } else {
            this.isVisibleVodButton = false
          }
        }).catch(() => {
          this.isVisibleVodButton = false
        })
      }
    },
    async actionButtonSetting () {
      const data = await actionButtonStateInfoData('live', this.channelInfo)
      this.isVisible = _.get(data, 'isVisible', true)
      this.title = _.get(data, 'title', '')
      this.action = _.get(data, 'action', '')
    }
  },
  created () {
    this.actionButtonSetting()
    this.updateVodButton(this.channelInfo)
    titleTagNameChange(`${_.get(this.channelInfo, 'title', '프로그램 상세화면')} : 웨이브`)
  },
  mounted () {
    let options = {}
    options[PLAYER_OPTIONS.IS_SEPARATE_UI] = false
    playerDelegate(this, this.$refs.container, PlayerType.MAIN, PLAYER_PACKAGE_TYPE.SET_PC, options)
  },
  beforeDestroy () {
    this.$events.$off(PLAYER_UPDATE_EVENT)
    detachPlayerEvents()
    destroyPlayer()
  },
  watch: {
    channelId (newId, oldId) {
      if (newId !== oldId) {
        if (window.playerInstance) window.playerInstance.load('live', this.channelId, null, null, true)
      }
    },
    channelInfo (newInfo, oldInfo) {
      titleTagNameChange(`${_.get(this.channelInfo, 'title', '프로그램 상세화면')} : 웨이브`)
      this.actionButtonSetting()
      // const newProgramId = _.get(newInfo, 'programid', '')
      // const oldProgramId = _.get(oldInfo, 'programid', '')
      // if (newProgramId !== '' && newProgramId !== oldProgramId) {
        this.updateVodButton(newInfo)
      // }
    }
  }
}
</script>
